import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPhone, FiMapPin, FiMail, FiClock } = FiIcons;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-lg flex items-center justify-center shadow-lg">
                <span className="text-white font-bold text-2xl font-serif">R</span>
              </div>
              <div>
                <h3 className="text-xl font-bold font-serif text-yellow-400">Red Rose Jewellery</h3>
                <p className="text-gray-300 text-sm">Premium Gold & Diamond Jewelry</p>
              </div>
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Experience the finest collection of gold and diamond jewelry in Dubai. We specialize in 
              custom designs, wedding jewelry, and premium accessories that reflect your unique style 
              and elegance.
            </p>
            <div className="flex flex-wrap gap-4">
              <div className="flex items-center space-x-2 text-sm text-gray-300">
                <SafeIcon icon={FiClock} className="w-4 h-4 text-yellow-400" />
                <span>Open Daily 9 AM - 10 PM</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-yellow-400">Quick Links</h4>
            <ul className="space-y-2">
              {[
                { path: '/', label: 'Home' },
                { path: '/services', label: 'Services' },
                { path: '/about', label: 'About Us' },
                { path: '/contact', label: 'Contact Us' }
              ].map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path} 
                    className="text-gray-300 hover:text-yellow-400 transition-colors duration-200 text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-yellow-400">Contact Info</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <SafeIcon icon={FiPhone} className="w-4 h-4 text-yellow-400 mt-0.5 flex-shrink-0" />
                <a 
                  href="tel:+971508087073" 
                  className="text-gray-300 hover:text-yellow-400 transition-colors duration-200 text-sm"
                >
                  +971 50 808 7073
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <SafeIcon icon={FiMapPin} className="w-4 h-4 text-yellow-400 mt-0.5 flex-shrink-0" />
                <span className="text-gray-300 text-sm leading-relaxed">
                  Al Satwa Rd - D90<br />
                  Dubai, UAE
                </span>
              </li>
              <li className="flex items-start space-x-3">
                <SafeIcon icon={FiMail} className="w-4 h-4 text-yellow-400 mt-0.5 flex-shrink-0" />
                <span className="text-gray-300 text-sm">info@redrosejewellery.ae</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Border */}
        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-center md:text-left">
              <p className="text-gray-400 text-sm">
                © {currentYear} Red Rose Jewellery. All rights reserved.
              </p>
              <p className="text-gray-500 text-xs mt-1">
                Designed with ❤️ for premium jewelry experience
              </p>
            </div>
            <div className="flex items-center space-x-6">
              <span className="text-gray-500 text-xs">Dubai, UAE</span>
              <a 
                href="https://maps.app.goo.gl/jEEn8MF5BUkM4oxv9" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-yellow-400 hover:text-yellow-300 transition-colors duration-200 text-xs"
              >
                View on Map
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;